import { bindable, autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Account } from '../../models/customer';
import { State } from '../../services/global-state';
import { SinglePaymentRouteSettings } from '../../models/single-payment/single-payment-route-settings';

@autoinject
export class ViewInstallments {
	account: Account;
	allowConsumerToCancelPaymentPlan: boolean;
	allowSkippingOfPayments: boolean;
	showActionsButton: boolean;
	isCombinedAccountPaymentPlan: boolean;
	plan:any;

	constructor(private state: State, private router: Router) {
	}

	activate(params) {
		this.account = this.state.accounts.find((element, index, array) => {
			return element.id === params.id;
		});
		this.state.business.applyPortfolioSettingsToPortal(this.account.portfolioName, false);

		let portfolioPortalSettings = this.state.business.fetchPortfolioSettings(this.account.portfolioName).settings;

		this.allowConsumerToCancelPaymentPlan = portfolioPortalSettings.paymentTypes.allowConsumerToCancelPaymentPlan;
		this.allowSkippingOfPayments = portfolioPortalSettings.paymentTypes.allowConsumersToSkipAPayment;

		this.showActionsButton = this.allowSkippingOfPayments || this.allowConsumerToCancelPaymentPlan;
	}

	goBack() {
		this.router.navigateBack();
	}

	payOffEarly() {
		if (this.plan.isCombinedCustomerAccount) return;
		let routeSettings: SinglePaymentRouteSettings = new SinglePaymentRouteSettings();
		routeSettings.payInFull = false;
		routeSettings.isPayOffEarly = true;
		routeSettings.selectedCustomerAccountKeys = [ this.account.customerAccountKey ];
		this.router.routes.find((routeConfig) => routeConfig.name === 'single-payment/single-payment').settings = routeSettings;

		// assume only one account can be selected
		this.router.navigateToRoute(`single-payment/single-payment`, { id: this.account.id });
	}

	cancelPlan() {
		let route = this.router.routes.find(
			x => x.name === 'installments/cancel-installments'
		);

		this.router.navigateToRoute(route.name, {
			id: this.account.id
		});
	}

	skipPayments() {
		if (this.plan.isCombinedCustomerAccount) return;
		let route = this.router.routes.find(
			x => x.name === 'skipPlanPayments'
		);

		route.accountId = this.account.id;

		this.router.navigateToRoute(route.name);
	}
}
